import { apiClient, ApiResponse, extractData } from './api'
import type {
  PixPayment,
  BoletoPayment,
  CreditCardPayment,
  CreditCardFormData,
  SavedCard,
} from '@/types/payment'

export const paymentService = {
  /**
   * Criar pagamento PIX
   */
  async createPixPayment(orderId: string): Promise<PixPayment> {
    const response = await apiClient.post<ApiResponse<PixPayment>>('/payment/pix', {
      order_id: orderId,
    })
    return extractData(response)
  },

  /**
   * Criar boleto bancário
   */
  async createBoleto(orderId: string): Promise<BoletoPayment> {
    const response = await apiClient.post<ApiResponse<BoletoPayment>>('/payment/boleto', {
      order_id: orderId,
    })
    return extractData(response)
  },

  /**
   * Processar cartão de crédito
   */
  async processCreditCard(data: CreditCardFormData): Promise<CreditCardPayment> {
    const response = await apiClient.post<ApiResponse<CreditCardPayment>>(
      '/payment/credit-card',
      data
    )
    return extractData(response)
  },

  /**
   * Processar com cartão salvo
   */
  async processSavedCard(
    orderId: string,
    savedCardId: number,
    cvv: string,
    installments: number = 1
  ): Promise<CreditCardPayment> {
    const response = await apiClient.post<ApiResponse<CreditCardPayment>>('/payment/credit-card', {
      order_id: orderId,
      saved_card_id: savedCardId,
      cvv,
      installments,
    })
    return extractData(response)
  },

  /**
   * Listar cartões salvos
   */
  async listCards(): Promise<SavedCard[]> {
    const response = await apiClient.get<ApiResponse<{ cards: SavedCard[] }>>('/payment/wallet')
    const data = extractData(response)
    return data.cards
  },

  /**
   * Salvar novo cartão
   */
  async saveCard(cardHash: string, setAsDefault: boolean = false): Promise<SavedCard> {
    const response = await apiClient.post<ApiResponse<{ card: SavedCard }>>('/payment/wallet', {
      card_hash: cardHash,
      set_as_default: setAsDefault,
    })
    const data = extractData(response)
    return data.card
  },

  /**
   * Remover cartão
   */
  async removeCard(cardId: number): Promise<void> {
    await apiClient.delete(`/payment/wallet/${cardId}`)
  },
}
